import { useRecordListingViewMutation as e } from "./useRecordListingViewMutation.mjs";
import { useIsAuthenticated as t } from "@maat/store-auth";
import { useEffect as n, useRef as r } from "react";
//#region src/recentlyViewed/useRecordListingView.ts
var i = (i, a) => {
	let o = t(), { mutate: s } = e(), c = r(/* @__PURE__ */ new Set());
	n(() => {
		!o || !i || c.current.has(i) || (c.current.add(i), s({
			listing_id: i,
			platform: a
		}));
	}, [
		o,
		i,
		a,
		s
	]);
};
//#endregion
export { i as useRecordListingView };
